export const LC_WORKSPACE_CARD_LIMIT = 10;

interface WorkspaceCard {
  key: string;
  workspaceId?: string;
  visible: boolean;
  hidden?: boolean;
}

export const isWorkspaceCardShown = (card: WorkspaceCard, showHidden = false): boolean =>
  card.visible && (!card.hidden || showHidden);

export const countWorkspaceCards = (cards: WorkspaceCard[], workspaceId: string): number =>
  cards.filter(card => card.workspaceId === workspaceId && isWorkspaceCardShown(card)).length;

export const canSaveWorkspaceCard = (
  cards: WorkspaceCard[], workspaceId: string, hidden = false, editingKey?: string,
): boolean => hidden || countWorkspaceCards(cards.filter(card => card.key !== editingKey), workspaceId) < LC_WORKSPACE_CARD_LIMIT;
